import Control from "../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROServiceEntreprise = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig } = useRCPROQuestion({
    company,
  });

  const activityKey = "servicesEntreprises";

  return (
    <div>
      <Control
        label={inputsConfig.servicesEntreprisesNatureService.label}
        type="checkBtnList"
        name="servicesEntreprisesNatureService"
        value={company.RCPRO.servicesEntreprisesNatureService}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.servicesEntreprisesNatureService.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles.</>}
      />
      {company.RCPRO.servicesEntreprisesNatureService.includes(4) && (
        <Control
          label={inputsConfig.servicesEntreprisesAutreActivite.label}
          type="text"
          name="servicesEntreprisesAutreActivite"
          value={company.RCPRO.servicesEntreprisesAutreActivite}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          onBlur={onBlur}
          required
        />
      )}
      <Control
        label={inputsConfig.servicesEntreprisesInterventionChezClient.label}
        type="btnList"
        name="servicesEntreprisesInterventionChezClient"
        value={company.RCPRO.servicesEntreprisesInterventionChezClient}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.servicesEntreprisesInterventionChezClient.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROServiceEntreprise;
